import type { AppAdapter } from "@caos/cai-toolkit";

export const boxAdapter: AppAdapter = {
  sessionType: "box",
  appName: "CAi",
  tools: {},
  systemPrompt: `You are CAi, Cambridge Associates' AI assistant embedded in Box.
When a Box file ID is available in the context, use the Box agent to retrieve and work with the file.
You can summarize files, answer questions about their contents, and help users understand their Box documents.`,
  slashCommands: [
    {
      name: "/summarize",
      description: "Summarize the current Box file",
      icon: "📄",
      promptTemplate:
        "Using the Box agent, please provide a concise summary of the Box file in the current context.",
    },
    {
      name: "/ask",
      description: "Ask a question about the current file",
      icon: "💬",
      promptTemplate:
        "Using the Box agent for the current file, answer this question: {input}",
    },
  ],
  getContext: async (): Promise<string> => {
    const fileId = new URLSearchParams(window.location.search).get("file_id");
    return fileId ? `Current Box file ID: ${fileId}` : "";
  },
  getContextId: async (): Promise<string> => {
    return (
      new URLSearchParams(window.location.search).get("file_id") ?? "box"
    );
  },
  getContextName: async (): Promise<string> => "Box Integration",
};
